import { createReducer, on } from '@ngrx/store';
import * as DataActions from './data.actions';
import * as AuthActions from '../auth/auth.actions';

export interface DataState {
  [key: string]: {
    data: any;
    settings: any;
    loading: boolean;
    error: any;
    lastUpdated: number;
  };
}

export const initialState: DataState = {};

export const dataReducer = createReducer(
  initialState,
  on(AuthActions.resetAllState, () => {
    return initialState;
  }),
  on(DataActions.loadData, (state, { dataSourceKey }) => {
    const key = dataSourceKey ?? '';
    if (!key) return state;
    return {
      ...state,
      [key]: {
        ...state[key],
        loading: true,
        error: null
      }
    };
  }),
  
  on(DataActions.loadDataSuccess, (state, { dataSourceKey, data, settings }) => ({
    ...state,
    [dataSourceKey as string]: {
      data,
      settings,
      loading: false,
      error: null,
      lastUpdated: Date.now()
    }
  })),
  
  on(DataActions.loadDataFailure, (state, { dataSourceKey, error }) => ({
    ...state,
    [dataSourceKey as string]: {
      ...state[dataSourceKey as string],
      loading: false,
      error
    }
  })),
  
  on(DataActions.clearData, (state, { dataSourceKey }) => {
    const newState = { ...state };
    delete newState[dataSourceKey as string];
    return newState;
  }),

  on(DataActions.clearAllData, () => initialState)
); 